import {
  Alert,
  APIActions,
  Button,
  ContentTemplate,
  CustomDialog,
  Grid,
  MUIDataTable,
  SectionHeader,
  TableActionTypes,
  useDataTable,
} from 'web-library';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';


import { makeStyles } from 'tss-react/mui';
import SelectExamLevelModal from '../../../../components/modals/SelectExamLevelModal';
import RouteKey from '../../../../routes/key';
import {
  useDeleteGroupRegistration,
  useGetWithdrawals,
} from '../../../../api/candidate/exam/@coordinator/queries-services/queries';
import TableColumnDefinition from './TableColumnDefinition';
import { GroupWithdrawal } from '../../../../api/candidate/exam/model';

const { withdrawal } = RouteKey.child;
const { withdrawal: withdrawalRoute, instruction } = RouteKey.withdrawal.child;

const useStyles = makeStyles()((theme) =>
({
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  alert: {
    marginBottom: theme.spacing(3),
  },
}));

const checkWindowClosed = (
  res: GroupWithdrawal[],
  setClosedExamLevels: (examLevel: string[]) => void,
  setWindowClosed: (windowClose: boolean) => void
) => {
  const examLevels: string[] = [];

  res.forEach((withdrawalDetail) => {
    if (withdrawalDetail.closedExamLevels) {
      withdrawalDetail.closedExamLevels.forEach((examLevel) => {
        if (!examLevels.includes(examLevel)) {
          examLevels.push(examLevel);
        }
      });
    }
  });

  if (examLevels.length) {
    setClosedExamLevels(examLevels);
    setWindowClosed(true);
  }
};

const Listing = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const history = useHistory();
  const [openModal, setOpenModal] = useState(false);
  const [closedExamLevels, setClosedExamLevels] = useState<string[]>();
  const [windowClosed, setWindowClosed] = useState(false);
  const [deleteData, setDeleteData] = useState('');
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const { state: tableState, dispatch: tableDispatch } = useDataTable();
  const { mutate: deleteWithdrawal } = useDeleteGroupRegistration(() => refetch());
  const { isLoading, refetch } = useGetWithdrawals((res) => {
    tableDispatch({
      type: 'UPDATE_DATA',
      payload: {
        data: res,
        count: res.length,
      },
    } as TableActionTypes);

    checkWindowClosed(res, setClosedExamLevels, setWindowClosed);
  });

  const handleCloseDeleteModal = () => setOpenDeleteModal(false);

  const handleDelete = () => {
    if (deleteData) {
      deleteWithdrawal(deleteData);
    }

    handleCloseDeleteModal();
  };

  const handleProceed = (examLevel: string) =>
    history.push(`/${withdrawal}/${withdrawalRoute.route}/${instruction.route}/${examLevel}`);

  const tableColumns = TableColumnDefinition(tableState, setOpenDeleteModal, setDeleteData);

  return (
    <ContentTemplate transparent continuous type="full">
      <Grid className={classes.headerContainer}>
        <SectionHeader title={t('withdrawal->>Coordinator.Listing.SectionHeader')} />
        <Button
          id="button-group-withdrawal-new-request"
          onClick={() => setOpenModal(true)}
          variant="contained"
          color="secondary"
        >
          {t('withdrawal->>Coordinator.Listing.NewRequest')}
        </Button>
      </Grid>
      {windowClosed && (
        <Alert
          className={classes.alert}
          variant="filled"
          severity="error"
          message={t('withdrawal->>Coordinator.Listing.RegistrationUnavailable', {
            examLevels: closedExamLevels?.join(', '),
          })}
        />
      )}
      <MUIDataTable
        state={tableState}
        dispatch={tableDispatch}
        columns={tableColumns}
        data={tableState.data}
        emptyDataLabel={t('withdrawal->>Coordinator.Listing.Empty')}
        isLoading={isLoading}
      />
      {openModal && (
        <SelectExamLevelModal
          handleProceed={handleProceed}
          examRegistrationType="EXAM_WITHDRAWAL"
          modalState={openModal}
          onDialogClose={() => setOpenModal(false)}
        />
      )}
      <CustomDialog
        open={openDeleteModal}
        title={t('accessArrangement->>AccessArrangements.Delete Title')}
        message={t('accessArrangement->>AccessArrangements.Delete Message')}
        action={
          <APIActions
            onClose={handleCloseDeleteModal}
            apiCall={handleDelete}
            cancelString={t('accessArrangement->>AccessArrangements.Cancel')}
            apiString={t('accessArrangement->>AccessArrangements.Proceed')}
          />
        }
      />
    </ContentTemplate>
  );
};
export default Listing;
